module.exports = __webpack_public_path__ + "assets/img/process-section.ff92b5dd.png";